export { _parse as parse };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

import standard from '../static/standard-suffixes.json';
import longScale from '../static/long-scale-suffixes.json';
import { requireDecimal } from './decimal.js';

//const suffixGroups = {standard, longScale}
var suffixGroups = { standard: standard }; // TODO longscale parsing. There's a duplicate
var suffixGroupsToExp = {};
for (var _iterator = Object.keys(suffixGroups), _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
  var _ref;

  if (_isArray) {
    if (_i >= _iterator.length) break;
    _ref = _iterator[_i++];
  } else {
    _i = _iterator.next();
    if (_i.done) break;
    _ref = _i.value;
  }

  var groupName = _ref;

  var group = suffixGroups[groupName];
  var suffixToExp = suffixGroupsToExp[groupName] = {};
  for (var _iterator2 = Object.keys(group), _isArray2 = Array.isArray(_iterator2), _i2 = 0, _iterator2 = _isArray2 ? _iterator2 : _iterator2[Symbol.iterator]();;) {
    var _ref2;

    if (_isArray2) {
      if (_i2 >= _iterator2.length) break;
      _ref2 = _iterator2[_i2++];
    } else {
      _i2 = _iterator2.next();
      if (_i2.done) break;
      _ref2 = _i2.value;
    }

    var fkey = _ref2;

    var fg = group[fkey];
    for (var index in fg) {
      var suffix = fg[index].toLowerCase();
      var exp = index * 3;
      if (suffixToExp[suffix] && suffixToExp[suffix].exp === exp, "duplicate parsenumber suffix with different exponents: " + suffix) suffixToExp[suffix] = { index: index, exp: exp, replace: 'e' + exp };
    }
  }
}

var backends = {
  'native': {
    parseInt: function parseInt(text, config) {
      var val = Math.ceil(Number(text, 10));
      return 'default' in config && !this.isValid(val) ? config['default'] : val;
    },
    isValid: function isValid(val) {
      return (val || val === 0) && !Number.isNaN(val);
    }
  },
  'decimal.js': {
    parseInt: function parseInt(text, config) {
      try {
        var Decimal = requireDecimal(config);
        var val0 = new Decimal(text);
        // decimal.js-light doesn't have ceil; use the more general rounding fn.
        // Not yet worth a separate adapter.
        var val = val0.ceil ? val0.ceil() : val0.toDecimalPlaces(0, Decimal.ROUND_UP);
        return this.isValid(val) ? val : config['default'];
      } catch (e) {
        if ('default' in config) return config.default;
        throw e;
      }
    },
    isValid: function isValid(val) {
      // decimal.js-light doesn't have isNaN(), it just throws. Test for isNaN only if it exists.
      return val && (!val.isNaN || !val.isNaN());
    }
  }
};

function _parse(text) {
  var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  if (!text) return config['default'] || null;
  // TODO make this an option
  var suffixToExp = suffixGroupsToExp[config.suffixGroup || 'standard'];
  var backend = backends[config.backend || 'native'];
  if (!backend) throw new Error('no such backend: ' + config.backend);
  // remove commas. TODO: i18n fail
  text = text.replace(/,/g, '');
  // replace suffixes ('billion', etc)
  var match = / ?[a-zA-Z]+/.exec(text);
  if (match && match.length > 0) {
    var exp = suffixToExp[match[0].toLowerCase()];
    if (exp) {
      // ceil(): buy at least this many. The default of floor() is annoying when
      // we're trying to purchase exactly-n for an upgrade.
      return backend.parseInt(text.replace(match[0], exp.replace), config);
    }
  }
  // no/invalid suffix found
  // note that we also get here for a suffix of 'e', like '1e3', because it's not
  // used as a suffix. Decimal.js will parse it.
  return backend.parseInt(text, config);
}

export var Parser = function () {
  function Parser(config) {
    _classCallCheck(this, Parser);

    this.config = config;
  }

  Parser.prototype.parse = function parse(text) {
    var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    return _parse(text, _extends({}, this.config, config));
  };

  return Parser;
}();